import { translate } from 'rhg-vue-common'

export const stayLabels = [
  'boUpgradeTierMessageStay1',
  'boUpgradeTierMessageStay2',
  'boUpgradeTierMessageStay34',
  'boUpgradeTierMessageStay34'
]

export const nightLabels = [
  'boUpgradeTierMessageNight1',
  'boUpgradeTierMessageNight2',
  'boUpgradeTierMessageNight34',
  'boUpgradeTierMessageNight34'
]

const useNextTierLabel = (condition = 'Stay', num = 0, labels = [], both = false) => {
  if (both) return translate('boUpgradeTierMessageOr', undefined)
  if (num < 5) {
    const label = labels.find((_, idx) => idx + 1 === num)
    return translate(label, undefined, num)
  } else if (['2', '3', '4'].some(char => num.toString().endsWith(char))) {
    return translate(`boUpgradeTierMessage${condition}52`, undefined, num)
  } else {
    return translate(`boUpgradeTierMessage${condition}51`, undefined, num)
  }
}

export default useNextTierLabel
